import ContentExpander from './content-expander';
import './content-expander.scss';

export default ContentExpander;
